import BaseStore from 'fluxible/addons/BaseStore';
import Actions from "../constants/Actions";

class EntertainerResultStore extends BaseStore {
  constructor(dispatcher) {
    super(dispatcher);
    this.userfavourite = [];
    this.inputs = [];
  }
  handleUserfavouriteEntertainer(data) {
    this.userfavourite = data.data;
    this.inputs = data.inputs;
    this.emitChange();
  }
  handleUpdateFeedbackUserfavouriteEntertainer(data) {
    // TODO:
    data.results = data.results.map(function(result) {
      result.index = result.index + data.index;
      return result;
    });
    this.userfavourite = this.userfavourite.slice(0, data.index).concat(data.results);
    this.emitChange();
  }
  get() {
    return {
      userfavourite: this.userfavourite,
      inputs: this.inputs
    };
  }
  dehydrate() {
    return {
      userfavourite: this.userfavourite,
      inputs: this.inputs
    };
  }
  rehydrate(state) {
    this.userfavourite = state.userfavourite;
    this.inputs = state.inputs;
  }
}

EntertainerResultStore.storeName = 'EntertainerResultStore';
EntertainerResultStore.handlers = {
  [Actions.UPDATE_FEEDBACK_USERFAVOURITE_ENTERTAINER_SUCCESS]: 'handleUpdateFeedbackUserfavouriteEntertainer',
  [Actions.LOAD_USERFAVOURITE_ENTERTAINER_SUCCESS]: 'handleUserfavouriteEntertainer'
};

export default EntertainerResultStore;



// WEBPACK FOOTER //
// ./src/stores/EntertainerResultStore.js